import React, {ForwardedRef, forwardRef} from 'react'

import Typography, {TypographyProps} from '../Typography'

export const PrimaryCell = forwardRef(
  (props: TypographyProps, ref: ForwardedRef<HTMLSpanElement>) => (
    <Typography ref={ref} color="textPrimary" variant="body2" component="div" {...props} />
  )
)
